<template>
  <div
    v-if="permission?.noticeMessage || permission?.noticeId"
    class="permission-notice"
  >
    <span>{{ permission?.noticeMessage ?? '' }}</span>
    <button v-if="permission?.noticeId" @click="onClick">자세히보기</button>
  </div>
</template>
<script setup>
  import { defineProps } from 'vue'
  import { useRouter } from 'vue-router/composables'

  const props = defineProps({
    /**
     * @type {{action: string, display: string, noticeMessage: string, noticeId: string}}
     */
    permission: {
      type: Object,
      default: () => {},
    },
  })

  const router = useRouter()
  const onClick = () => {
    router.push({
      path: '/customer/notice_view',
      query: { noticeId: props?.permission?.noticeId },
    })
  }
</script>
<style lang="scss">
  @import '@/assets/scss/import/_mixin.scss';
  @import '@/assets/scss/import/_color.scss';
  .permission-notice {
    color: $system-red;
    font-size: 16px;
    span {
      margin-right: 8px;
    }
    button {
      color: inherit;
      font-size: inherit;
      font-weight: 700;
      text-decoration-line: underline;
    }
  }
</style>
